var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"masthead__lower"},[_c('div',{staticClass:"masthead__sub-headline"},[_c('h3',[_vm._t("subHeadlineUpper")],2),_vm._v(" "),_c('h3',[_vm._t("subHeadlineLower")],2),_vm._v(" "),_c('p',[_vm._t("subHeadlineContent")],2)]),_vm._v(" "),_c('div',{staticClass:"masthead__cta"},[_vm._t("cta")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a855f3e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/MastheadVideo.vue
// module id = null
// module chunks = 